import { useState } from "react";
import { format, getMonth, getYear } from "date-fns";
import DatePicker, { registerLocale } from "react-datepicker";
import { enUS  } from "date-fns/esm/locale";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../css/style.css";

const DatePickerWrapper = () => {
    const [startDate, setStartDate] = useState(new Date());

    const formatDate = (date) => {
      let validDate = date;
      
      if (typeof date === 'string' && date.includes('.')) {
        const [day, month, year] = date.split('.').map(num => parseInt(num, 10));
        validDate = new Date(year, month - 1, day); 
      } else {
        validDate = new Date(date); 
      }
      
      if (isNaN(validDate)) {
        console.error('Invalid date value:', date); 
        return ''; 
      }
  
      return format(validDate, 'd-M-yyyy'); 
    };
  
    const CustomInput = ({ onClick, value }) => {
      return (
        <div>
          <label className="form-control">
            <i
              className="fa-regular fa-calendar me-0 pe-0"
              style={{
                fontSize: "18px",
                color: "#ea1d25", // Optional: Change icon color if needed
                pointerEvents: "none",
              }}
            ></i>
          <input
            onFocus={onClick}
            className="border-0 ms-0 ps-2"
            value={value ? formatDate(value) : ""}
            style={{
              paddingLeft: "30px", 
            }}
          />
          </label>
        </div>
      );
    };

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    
    registerLocale("enUS ", enUS );
    return (
      <>
        <DatePicker
            locale="enUS"
            customInput={<CustomInput />}
            wrapperClassName="datePickerWrapper w-100"
            className="form-control"
            dayClassName={(date) => date.getDate() === new Date().getDate() + 1}
            renderCustomHeader={({
              date,
              changeMonth,
              changeYear,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* Previous Month Button */}
                <button
                  className="change-month-icon"
                  disabled={nextMonthButtonDisabled}
                  onClick={increaseMonth}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                {/* Month Dropdown */}
                <select
                  className="select-month"
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                {/* Year Dropdown */}
                <select
                  className="select-year"
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(Number(value))}
                  style={{ marginLeft: 10 , border:0, width: '80px'}} // To space out from the month dropdown
                >
                  {/* Example years, you can adjust the range */}
                  {[...Array(50).keys()].map((i) => {
                    const year = 2020 + i;
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>

                {/* Next Month Button */}
                <button
                  className="change-month-icon"
                  disabled={prevMonthButtonDisabled}
                  onClick={decreaseMonth}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            )}
            popperClassName="custom-datepicker-popper"
            popperPlacement="bottom"
            dateFormat="dd.MM.yyyy"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
          />
        </>
      );
};

export default DatePickerWrapper;
